import { render, staticRenderFns } from "./PaymentPage.vue?vue&type=template&id=38802fd7&scoped=true&"
import script from "./PaymentPage.vue?vue&type=script&lang=js&"
export * from "./PaymentPage.vue?vue&type=script&lang=js&"
import style0 from "./PaymentPage.vue?vue&type=style&index=0&id=38802fd7&scoped=true&lang=css&"
import style1 from "@/assets/css/success.css?vue&type=style&index=1&id=38802fd7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38802fd7",
  null
  
)

export default component.exports